var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPremium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.495 13.4637L4.69 15.0278L4.948 16.9748C5.091 18.0548 5.94 18.9047 7.02 19.0487L8.972 19.3097L10.535 20.5037C11.4 21.1647 12.599 21.1647 13.464 20.5037L15.028 19.3088H15.026L16.974 19.0508C18.054 18.9078 18.904 18.0588 19.048 16.9788L19.308 15.0267C19.308 15.0278 19.912 14.2367 20.503 13.4637C21.164 12.5988 21.163 11.3997 20.503 10.5347L19.31 8.97075L19.052 7.02375C18.909 5.94375 18.06 5.09375 16.98 4.94975L15.027 4.68975L13.464 3.49575C12.599 2.83475 11.4 2.83475 10.535 3.49575L8.971 4.68975H8.973L7.025 4.94875C5.945 5.09175 5.095 5.94075 4.951 7.02075L4.69 8.97275C4.69 8.97175 4.086 9.76275 3.495 10.5357C2.835 11.3997 2.835 12.5997 3.495 13.4637Z",
    fill: "#0000FF",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7194 11.1836V9.90659C13.7194 9.00259 12.9484 8.18359 11.9964 8.18359C11.0444 8.18359 10.2734 8.95459 10.2734 9.90659V11.1836",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.026 15.1836H9.974C9.436 15.1836 9 14.7476 9 14.2096V12.1576C9 11.6196 9.436 11.1836 9.974 11.1836H14.026C14.564 11.1836 15 11.6196 15 12.1576V14.2096C15 14.7476 14.564 15.1836 14.026 15.1836Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPremium);
export default __webpack_public_path__ + "static/media/icon-premium.c1444a0a5234532ffc1163028ce84584.svg";
export { ForwardRef as ReactComponent };